const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-calendar",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-calendar1",
    serifid: "iconS-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.321,3.304l0,1.304l5.358,0l-0,-1.304c-0,-0.72 0.598,-1.304 1.339,-1.304c0.741,0 1.339,0.584 1.339,1.304l0,1.304l2.009,0c1.109,0 2.009,0.876 2.009,1.956l0,1.21l-18.75,0l0,-1.21c0,-1.08 0.899,-1.956 2.009,-1.956l2.009,0l-0,-1.304c-0,-0.72 0.598,-1.304 1.339,-1.304c0.741,0 1.339,0.584 1.339,1.304Zm-6.696,5.656l18.75,-0l0,11.084c0,1.08 -0.9,1.956 -2.009,1.956l-14.732,0c-1.11,0 -2.009,-0.876 -2.009,-1.956l0,-11.084Zm2.679,4.564c-0,0.358 0.299,0.652 0.669,0.652l1.34,-0c0.368,-0 0.669,-0.294 0.669,-0.652l0,-1.304c0,-0.359 -0.301,-0.652 -0.669,-0.652l-1.34,-0c-0.37,-0 -0.669,0.293 -0.669,0.652l-0,1.304Zm5.357,-0c-0,0.358 0.301,0.652 0.669,0.652l1.34,-0c0.368,-0 0.669,-0.294 0.669,-0.652l0,-1.304c0,-0.359 -0.301,-0.652 -0.669,-0.652l-1.34,-0c-0.368,-0 -0.669,0.293 -0.669,0.652l-0,1.304Zm6.027,-1.956c-0.369,-0 -0.67,0.293 -0.67,0.652l-0,1.304c-0,0.358 0.301,0.652 0.67,0.652l1.339,-0c0.368,-0 0.669,-0.294 0.669,-0.652l0,-1.304c0,-0.359 -0.301,-0.652 -0.669,-0.652l-1.339,-0Zm-11.384,7.172c-0,0.359 0.299,0.652 0.669,0.652l1.34,-0c0.368,-0 0.669,-0.293 0.669,-0.652l0,-1.304c0,-0.359 -0.301,-0.652 -0.669,-0.652l-1.34,-0c-0.37,-0 -0.669,0.293 -0.669,0.652l-0,1.304Zm6.026,-1.956c-0.368,-0 -0.669,0.293 -0.669,0.652l-0,1.304c-0,0.359 0.301,0.652 0.669,0.652l1.34,-0c0.368,-0 0.669,-0.293 0.669,-0.652l0,-1.304c0,-0.359 -0.301,-0.652 -0.669,-0.652l-1.34,-0Zm4.688,1.956c-0,0.359 0.301,0.652 0.67,0.652l1.339,-0c0.368,-0 0.669,-0.293 0.669,-0.652l0,-1.304c0,-0.359 -0.301,-0.652 -0.669,-0.652l-1.339,-0c-0.369,-0 -0.67,0.293 -0.67,0.652l-0,1.304Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSCalendar);
export default __webpack_public_path__ + "static/media/iconS-calendar.8149bf0688f33b4d32fd7b1011a15ee5.svg";
export { ForwardRef as ReactComponent };